import { Route } from 'types/route.type';
import ProductDeclaration from './components/product-declaration';
import ViewOrder from './components/view-order';
import OrderHistory from './order-history';

export const routes: Route[] = [
  {
    path: '/order-feed/order-history/:siteErpId?/:globalSiteId?',
    component: OrderHistory,
    id: 'orderFeed.navigation.orderHistory',
  },
  {
    path: '/order-feed/order-history/:siteErpId/:globalSiteId/:orderNumber',
    component: ViewOrder,
  },
  {
    path: '/order-feed/order-history/:siteErpId/:globalSiteId/:orderNumber/:lineNumber?',
    component: ProductDeclaration,
  },
];
